export default "__VITE_ASSET__35293bec__"